<template>
  <div>
    <grouped-view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="repairRegistrations/sign"
        :span-merge-keys="['masterBillNo']"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="otherBtn">
        <el-button type="primary" :disabled="!selection.length" @click="printHandleMB"> 模版打印</el-button>
        <el-button type="primary" :disabled="!selection.length" @click="batchJJ"> 批量修改</el-button>
        <el-button type="primary" :disabled="!selection.length" @click="batchJJSubmit"> 批量提交</el-button>
        <el-button type="primary" @click="batchReceive"> 批量接机</el-button>
        <el-button type="primary" @click="unifyBatch"> 统一批次</el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="接机时间">
            <el-date-picker
                v-model="receiveTimeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('receiveTimeRange', 'receiveTimeBegin', 'receiveTimeEnd')"/>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model.trim="filter.customerName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="条形码">
            <el-input v-model.trim="filter.barcode" placeholder="请输入条形码" clearable/>
          </el-form-item>
          <el-form-item label="接机编号">
            <el-input v-model.trim="filter.masterBillNo" placeholder="请输入物料编号" clearable/>
          </el-form-item>
          <el-form-item label="返厂快递单号">
            <el-input v-model.trim="filter.returnCourierNO" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filter.status" clearable placeholder="请选择状态">
              <el-option label="已接机" :value="-1"/>
              <el-option label="待签收" :value="0"/>
              <el-option label="已签收" :value="1"/>
              <el-option label="已修" :value="2"/>
              <el-option label="技术分析" :value="3"/>
              <el-option label="报废" :value="4"/>
              <el-option label="可用" :value="5"/>
              <el-option label="不可用" :value="6"/>
            </el-select>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="终端客户">
            <el-input v-model.trim="filter.terminalCustomerName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="客户联系人">
            <el-input v-model.trim="filter.consignee" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="客户联系方式">
            <el-input v-model.trim="filter.consigneeContact" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="接收人">
            <el-input v-model.trim="filter.receiveName" placeholder="请输入接收人" clearable/>
          </el-form-item>
          <el-form-item label="维修人">
            <el-input v-model.trim="filter.repairName" placeholder="请输入维修人" clearable/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="limits.subAuth"
            type="primary"
            :disabled="scope.row.status !== -1"
            :loading="submitLoading"
            @click="submitHandle(scope.row)">
          提交
        </el-button>
      </template>
    </grouped-view-table>
    <repair-registration-q-s-edit ref="repairRegistrationQSEdit" @save-success="loadData"/>
    <batch-j-j ref="batchJJ" @save-success="loadData"/>
    <el-dialog
        title="批量接机"
        :visible.sync="batchReceiveVisible"
        :close-on-click-modal="false"
        width="600px"
        @close="resetBatchReceive">
      <el-form :model="batchReceiveForm" label-width="100px">
        <el-form-item label="条形码">
          <el-input
              v-model="batchReceiveForm.barcode"
              placeholder="请输入条形码"
              clearable
              @keyup.enter.native="addBarcode">
            <el-button
                slot="append"
                icon="el-icon-check"
                type="primary"
                @click="addBarcode"/>
          </el-input>
        </el-form-item>
      </el-form>
      <div v-if="barcodeList.length > 0" class="barcode-list">
        <div class="barcode-list-title">条形码列表</div>
        <div class="barcode-items">
          <el-tag
              v-for="(barcode, index) in barcodeList"
              :key="index"
              closable
              class="barcode-item"
              @close="removeBarcode(index)">
            {{barcode}}
          </el-tag>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetBatchReceive">取消</el-button>
        <el-button type="primary" @click="confirmBatchReceive">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import GroupedViewTable from "@/components/GroupedViewTable.vue";
  import RepairRegistrationQSEdit from "@/views/maintenanceManage/repairRegistrationJJ/RepairRegistrationJJEdit";
  import BatchJJ from "@/views/maintenanceManage/repairRegistrationJJ/BatchJJ";

  export default {
    name: "RepairRegistrationJJList",
    components: {BatchJJ, RepairRegistrationQSEdit, GroupedViewTable},
    data() {
      return {
        limits: {
          addAuth: this.$auth(621),
          editAuth: this.$auth(621),
        },
        submitLoading: false,
        receiveTimeRange: [],
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        selection: [],
        createTime: "",
        filter: {
          billNo: "",
          barcode: "",
          masterBillNo: "",
          materialNo: "",
          returnCourierNO: "",
          materialName: "",
          receiveName: "",
          repairName: "",
          productionNo: "",
          beginCreateTime: "",
          endCreateTime: "",
          factoryNo: "",
          salesmanName: "",
          customerName: "",
          terminalCustomerName: "",
          consigneeContact: "",
          consignee: "",
          creatorName: "",
          serviceAddress: "",
          contact: "",
          siteMobile: "",
          status: -1,
          type: 10,
          receiveTimeBegin: "",
          receiveTimeEnd: "",
        },
        // 批量接机相关数据
        batchReceiveVisible: false,
        batchReceiveForm: {
          barcode: "",
        },
        barcodeList: [],
        columnsProperty: [
          {
            key: "masterBillNo",
            align: "center",
            width: 220,
            tooltip: true,
          },
          {
            key: "billNo",
            align: "center",
            width: 220,
            tooltip: true,
            // render: (h, params) => {
            //   return h(
            //     "span",
            //     {
            //       style: {
            //         color: "#2d8cf0",
            //         cursor: "pointer",
            //       },
            //       on: {
            //         click: () => {
            //           this.$router.push({
            //             path: "/ReplacementBillPreview",
            //             query: {
            //               billType: 13,
            //               billId: params.row.pkid,
            //               $tabName: params.row.billNo,
            //             },
            //           });
            //         },
            //       },
            //     },
            //     params.row.billNo,
            //   );
            // },
          },
          {
            key: "statusName",
            align: "center",
            width: 120,
            tooltip: true,
          },
          {
            key: "materialNo",
            align: "center",
            width: 120,
            tooltip: true,
          },
          {
            key: "materialName",
            align: "center",
            width: 220,
            tooltip: true,
          },
          {
            key: "typeName",
            align: "center",
            width: 120,
            tooltip: true,
          },
          {
            key: "receiveName",
            align: "center",
            width: 160,
            tooltip: true,
          },
          {
            key: "repairName",
            align: "center",
            width: 160,
            tooltip: true,
          },
          {
            key: "barcode",
            align: "center",
            width: 160,
            tooltip: true,
          },
          {
            key: "receiveTime",
            align: "center",
            width: 160,
            tooltip: true,
          },
          {
            key: "hardwareVersion",
            align: "center",
            width: 160,
            tooltip: true,
          },
          {
            key: "softwareVersion",
            align: "center",
            width: 160,
            tooltip: true,
          },
          {
            key: "historicalAlarms",
            align: "center",
            width: 160,
            tooltip: true,
          },
          {
            key: "faultReporting",
            align: "center",
            width: 160,
            tooltip: true,
          },
          {
            key: "faultActual",
            align: "center",
            width: 160,
            tooltip: true,
          },
          {
            key: "action",
            align: "center",
            width: 200,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.repairRegistrationQSEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
        this.selection = [];
      },
      submitHandle(row) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.submitLoading = true;
          this.$http.get("basic", `repairRegistrations/submitJJ/${row.pkid}`).then((resp) => {
            if (resp.success) {
              this.$message.success("提交成功");
              this.submitLoading = false;
              this.loadData();
            } else {
              this.submitLoading = false;
            }
          }).catch(() => {
            this.submitLoading = false;
          },
          );
        });
      },
      // 跳转打印页面
      printHandle() {
        const routeUrl = this.$router.resolve({
          path: "/repairWorkOrderPrint",
          query: {
            params: JSON.stringify(this.selection),
          },
        });
        window.open(routeUrl.href, "_blank");
      },
      printHandleMB() {
        let ids = [];
        this.selection.forEach(item => {
          ids.push(item.pkid);
        });
        this.$http.put("basic", "repairRegistrations/batchJJPrint", ids).then((resp) => {
          if (resp.success) {
            this.$message.success("操作成功");
            this.selection = [];
            this.loadData();
          }
        });
      },
      batchJJ() {
        let ids = [];
        this.selection.forEach(item => {
          ids.push(item.pkid);
        });
        this.$refs.batchJJ.open(ids);
      },
      batchJJSubmit() {
        let ids = [];
        this.selection.forEach(item => {
          ids.push(item.pkid);
        });
        this.$confirm("确定提交吗?", "提示", { type: "warning" }).then(() => {
          this.$http.put("basic", "repairRegistrations/batchJJSubmit", ids).then((resp) => {
            if (resp.success) {
              this.$message.success("操作成功");
              this.selection = [];
              this.loadData();
            }
          });
        });

      },
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
      createTimeChange(date) {
        if (date !== null) {
          this.filter.beginCreateTime = date[0];
          this.filter.endCreateTime = date[1];
        } else {
          this.filter.beginCreateTime = "";
          this.filter.endCreateTime = "";
        }
      },
      deleteHandle(row) {
        this.$http.delete("basic", "repairRegistrations", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = filter;
      },

      otherAuth(row) {
        return row.status !== -1;
      },
      // 批量接机相关方法
      batchReceive() {
        this.batchReceiveVisible = true;
      },
      unifyBatch() {
        console.log(this.selection);
      },
      addBarcode() {
        let barcode = this.batchReceiveForm.barcode.trim();
        if (barcode) {
          // 处理特定格式的条形码：以《*!开头且包含FSerialNum
          if (barcode.startsWith("《*！") && barcode.includes("FSerialNum：")) {
            // 正则表达式：匹配FSerialNum：后面到FAuxQty之前的内容
            const match = barcode.match(/FSerialNum：([\s\S]*?)FAuxQty/);
            if (match && match[1]) {
              barcode = match[1].trim().replace("|","");
            }
          }else if(barcode.startsWith("<*!") && barcode.includes("FSerialNum:")) {
            // 正则表达式：匹配FSerialNum：后面到FAuxQty之前的内容
            const match = barcode.match(/FSerialNum:([\s\S]*?)FAuxQty/);
            if (match && match[1]) {
              barcode = match[1].trim().replace("|","");
            }
          }
          // 处理包含2个'-'的条形码：截取两个'-'中间的字符串
          else if ((barcode.match(/-/g) || []).length === 2) {
            // 正则表达式：匹配两个'-'中间的内容
            const match = barcode.match(/-(.*?)-/);
            if (match && match[1]) {
              barcode = match[1].trim();
            }
          } 
          // 处理包含3个'-'的条形码：截取第二个'-'和第三个'-'中间的字符串
          else if ((barcode.match(/-/g) || []).length === 3) {
            // 使用字符串分割方法：先分割成数组，再取第2个元素
            const parts = barcode.split("-");
            if (parts.length === 4) {
              barcode = parts[2].trim();
            }
          }
          // 处理包含4个':'的条形码：截取第三个':'和第四个':'中间的字符串
          else if ((barcode.match(/:/g) || []).length === 4) {
            // 使用字符串分割方法：先分割成数组，再取第3个元素
            const parts = barcode.split(":");
            if (parts.length === 5) {
              barcode = parts[3].trim();
            }
          }
          
          if (!this.barcodeList.includes(barcode)) {
            this.barcodeList.push(barcode);
            this.batchReceiveForm.barcode = "";
          } else {
            this.$message.warning("该条形码已存在");
          }
        }
      },
      removeBarcode(index) {
        this.barcodeList.splice(index, 1);
      },
      resetBatchReceive() {
        this.batchReceiveVisible = false;
        this.batchReceiveForm.barcode = "";
        this.barcodeList = [];
      },
      confirmBatchReceive() {
        // 先检查输入框中是否有未添加的条形码
        if (this.batchReceiveForm.barcode.trim()) {
          this.addBarcode();
        }
        if (this.barcodeList.length === 0) {
          this.$message.warning("请至少输入一个条形码");
          return;
        }
        this.submitLoading = true;
        // 这里可以添加批量接机的逻辑，例如调用API
        this.$http.post("basic", "repairRegistrations/batchInsertByJJ", this.barcodeList).then((resp) => {
          if (resp.success) {
            this.$message.success("批量接机成功");
            this.submitLoading = false;
            this.resetBatchReceive();
            this.loadData();
          }else{
            this.submitLoading = false;
          }
        }).catch(() => {
          this.$message.error("批量接机失败");
          this.submitLoading = false;
        });
      },
    },
  };
</script>



<style scoped>
.barcode-list {
  margin-top: 20px;
}

.barcode-list-title {
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.barcode-items {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-height: 200px;
  overflow-y: auto;
  padding: 10px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background-color: #f9f9f9;
}

.barcode-item {
  margin-bottom: 5px;
}
</style>